import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import {
    ErrorModal,
    formatPhoneNumber,
    Config,
} from '@ratehub/base-ui';
import { ProviderPropType } from '@ratehub/ins-common';


function ErrorModalDefault({
    provider,
    onClose,
}) {
    function handleOnAccept() {
        onClose();
        // Using window.open because this function gets passed to an onClick and we can't use href
        window.open(Config.INS_LIFE_ERROR_MODAL_BOOKING_URL);
    }

    return (
        <ErrorModal
            title={(
                <FormattedMessage
                    id="InsLifeWizard.errorModalDefault.title"
                    defaultMessage="Sorry, we're having trouble submitting your quote request."
                />
            )}

            description={(
                <FormattedMessage
                    id="InsLifeWizard.errorModalDefault.description"
                    defaultMessage="You can connect directly with our life insurance partner {name}. Their team of licensed brokers will be more than happy to review your coverage needs. You can contact them directly at {phone}."
                    values={{
                        name: removeTrailingPeriod(provider.name),
                        phone: (
                            <a href={`tel:${provider.phoneNumber}`}>
                                {formatPhoneNumber(provider.phoneNumber)}
                            </a>
                        ),
                    }}
                />
            )}

            acceptText={(
                <FormattedMessage
                    id="InsLifeWizard.errorModalDefault.acceptText"
                    defaultMessage="Schedule a call"
                />
            )}

            onAccept={handleOnAccept}
            onClose={onClose}
        />
    );
}

ErrorModalDefault.propTypes = {
    provider: ProviderPropType.isRequired,
    onClose: PropTypes.func.isRequired,
};

function removeTrailingPeriod(text) {
    // If the last character is ".", remove it
    return text[text.length - 1] === '.'
        ? text.slice(0, -1)
        : text;
}

export default ErrorModalDefault;
